<template>
  <v-app class="app">
    <router-view :key="$route.path"></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
html, body, #app, .app {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  background-color: #121212;
}

#app, .app {
  display: flex;
  flex-direction: column;
}

::-webkit-scrollbar {
  width: 8px;
  background-color: #000;
}

::-webkit-scrollbar-thumb {
  background-color: #4caf50;
  border-radius: 4px;
}
</style>
